import { render } from "./ArtworksFilter.vue?vue&type=template&id=f2958182&scoped=true"
import script from "./ArtworksFilter.vue?vue&type=script&lang=js"
export * from "./ArtworksFilter.vue?vue&type=script&lang=js"

import "./ArtworksFilter.vue?vue&type=style&index=0&id=f2958182&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2958182"]])

export default __exports__